// The comm profile's ONE list — what `comm.symbols.app` (the communication
// host, workspace docs/COMM_HOST.md) serves. Every reader (the router guard,
// the nav filter, the header tabs) takes it from here; nothing restates it.
//
// Functions, not array consts: a module-level array is hoisted into the
// platform's globalScope and comes back as a keyed object in a consumer's
// fetched copy (`.map`/`.some` then throw). A function survives the round trip.

// The base paths a comm host serves. A path matches its base or any deeper
// sub-route (`/chat` covers `/chat/<channel>`). Everything else opens on the
// workspace host (my.symbols.app).
export const commRoutes = () => [
  // The communication apps (Nika 2026-10-23)
  '/chat',
  '/meet',
  '/meet-guest',
  '/inbox',
  '/calendar',
  '/mail',
  '/reminders',
  '/people',
  '/team-members',
  '/team-and-agents',
  '/profile',
  '/u',
  '/user',
  '/agents',
  '/my-agents',
  // The person's own settings
  '/settings',
  '/account',
  // Sign-in, invites and the session bridge — a comm host signs in on its own
  '/login',
  '/signin',
  '/signup',
  '/signup-confirmation',
  '/reset-password',
  '/auth',
  '/github-auth-callback',
  '/sign-in-session',
  '/_session-bridge',
  '/accept-invite',
  '/accept-org-invite',
  '/accept-team-invite',
  '/accept-workspace-invite',
  '/waitlist-invite',
  '/waitlist',
  '/404'
]

// Where a comm host lands: the bare `/` (the workspace home) is not served.
export const commHomePath = () => '/chat'

// The header tabs a comm host shows, in order — HEADER_TABS-shaped rows
// ({ key, label, path }) with existing bundle keys.
export const commNavTabs = () => [
  { key: 'chat', label: 'shell.app.chat', path: '/chat' },
  { key: 'meet', label: 'shell.app.meet', path: '/meet' },
  { key: 'inbox', label: 'shell.app.inbox', path: '/inbox' },
  { key: 'calendar', label: 'shell.app.calendar', path: '/calendar' },
  { key: 'mail', label: 'shell.app.mail', path: '/mail' },
  { key: 'reminders', label: 'shell.app.reminders', path: '/reminders' },
  { key: 'people', label: 'shell.app.people', path: '/team-members' },
  { key: 'agents', label: 'shell.app.agents', path: '/agents' }
]

// The AI modes a comm host offers — a conversation, the tools and Fly. The
// workspace modes that build (apps), lay out the home (dashboard) or present
// are the workspace host's.
export const commAssistantModes = () => ['assistant', 'tools', 'fly']
